import { useEffect, useState } from "react";
import { _single, _UBLInvoice } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { Modal } from "../../../../../../theme/Component/Modal";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import { SelectAccountantIDType } from "./SelectAccountantIDType";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { YearSelector } from "../../../../../../../core/shared/inputs/YearSelector";

interface confProps {
    label?: string;
}

interface Props {
    _Invoice: any;
    onChange: Function;
    ConfigProps?: confProps;
    renderValue?: string;
}


export const ReciablePaymentEditor = ({ _Invoice, onChange, ConfigProps, renderValue }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_UBLInvoice);
    const [value, setValue] = useState<string>("");
    const [year, setYear] = useState<number>(_single.getCurrenYear());

    const [modal, setModal] = useState<any>({ name: "Cuentas Contables", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const getLista = () => {
        instance.getAccountantIDForReceivable(accType, renderValue).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        );
    }

    useEffect(() => {
        setValue(renderValue);
    }, [renderValue])

    const head = [
        { title: 'Cuenta', property: 'AccountantIDStr', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
    ]

    const returnValue = () => {
        if (!bean.JsonCode) {
            toast.error("Seleccione una cuenta contable valida");
        } else {
            if (onChange) {
                onChange(bean);
            }
            setModal({ ...modal, view: false });
            setValue(bean.Name);
        }
    }

    const [accType, setAccType] = useState<number>(null);

    return (
        <>
            <label>{ConfigProps?.label ?? "Cuenta por Pagar"}</label>
            <input
                type="text"
                className="form-control"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
                placeholder="Buscar..."
                value={value}
                onClick={() => { setModal({ ...modal, view: true }); }}
            />

            <Modal modal={modal} updateModal={setModal} onSubmitLabel="Seleccionar Cuenta" eventModal={returnValue}  >
                <div className="row">
                    <div className="col-md-6">
                        <SelectAccountantIDType idSelector={accType} onChange={(e) => { setAccType(e) }} />
                    </div>
                    <div className="col-md-6 mt-4">
                        <BasicButton eventClick={getLista} icon="ri-search-line" children={"Buscar"} />
                    </div>
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} />
                    </div>
                </div>
            </Modal>
        </>
    )
};